var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    [
      _c(
        "div",
        { staticClass: "learning-path-container" },
        [
          _c("Header", { attrs: { "learning-path": _vm.learningPath } }),
          _vm._v(" "),
          _vm.isReady
            ? _c(
                "Swiper",
                {
                  ref: "swiper",
                  attrs: {
                    options: {
                      centeredSlides: true,
                      slidesPerView: "auto",
                      spaceBetween: 24,
                      slideToClickedSlide: true,
                      initialSlide: _vm.activeIndex,
                      allowTouchMove: true,
                      on: {
                        activeIndexChange: _vm.updateActiveIndex
                      },
                      keyboard: {
                        enabled: true
                      },
                      pagination: {
                        el: ".swiper-pagination",
                        type: "bullets",
                        clickable: true
                      }
                    }
                  }
                },
                _vm._l(_vm.learningPath.levels, function(level, index) {
                  return _c(
                    "SwiperSlide",
                    { key: level.number },
                    [
                      _c("LevelCard", {
                        attrs: {
                          "is-current-level": _vm.isCurrentLevel(level),
                          "is-placed-out": _vm.isPlacedOut(level),
                          "is-active": _vm.activeIndex === index,
                          "learning-path": _vm.learningPath,
                          level: level
                        },
                        on: {
                          "click-cta": _vm.openModal,
                          "click-card": function(l) {
                            return _vm.openModalOrUpdatePreviousIndex(l, index)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isReady
            ? _c("nav", { staticClass: "icon-navigator" }, [
                _c("div", { staticClass: "swiper-pagination" })
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalOpen
        ? _c("CoursesModal", {
            attrs: {
              learningPath: _vm.learningPath,
              level: _vm.learningPath.levels[_vm.activeIndex]
            },
            on: {
              close: function($event) {
                _vm.isModalOpen = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }